import { storeAvatar } from '@/api/advertiser'
import MaterialSelect from '@/components/material-select/MaterialSelect.vue'
import { getWorkers, verifyBindWorker } from '@/api/open'

export default {
    components: {
        MaterialSelect,
    },
    props: {
        showAvatarForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
            roles: [],
            corporations: [],
            loading: false,
            rules: {
                avatar: [{ required: true, message: '请选择广告主头像', trigger: 'change' }],
            },
            workers: [],
            admins: [],
            showCreateAppResult: true,
            result: {
                success: [],
                errors: [],
            },
            title: '上传/更新广告主头像',

        }
    },
    computed: {
        actType() {}
    },
    mounted() {
        if (this.model.bind_worker) {
            this.title = '绑定优化师并上传头像'
        }
        if (this.model.bind_worker) {
            getWorkers().then(res => {
                this.workers = res.data.list
            })
        }
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                // 校验是否已绑定优化师
                verifyBindWorker(this.model.id>0?this.model.id:this.model.ids,this.model.bind_worker).then(res => {
                    let boundAdvertiserIds = res.data.list || []
                    if (boundAdvertiserIds.length > 0) {
                        let idStr = boundAdvertiserIds.join(', ')
                        this.$confirm({
                            title: '提示',
                            content: `广告主 ID（${idStr}）已绑定优化师，是否继续进行绑定操作？`,
                            okText: '是',
                            cancelText: '否',
                            onOk: () => {
                                console.log('确认绑定优化师！')
                                this.storeAvatar()
                            },
                            onCancel: () => {
                                // 用户点击否，不做任何处理
                                console.log('取消绑定操作！')
                            }
                        })
                    } else {
                        console.log('直接绑定优化师！')
                        this.storeAvatar()
                    }
                    
                })
            })
        },
        storeAvatar() {
            this.result.success = []
            this.result.errors = []
            this.loading = true

            // console.log('提交的数据',this.model)
            if (!this.model.avatar.id) {
                return this.$message.error('请选择头像')
            }
            const json = {
                ids: this.model.id > 0 ? [this.model.id] : this.model.ids,
                source_info: this.model.source_info,
                avatar: this.model.avatar,
                worker_id: this.model.worker_id,
            }
            storeAvatar(json).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.result = res.data
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showAvatarForm', false)
        }
    }
}
